import * as React from 'react';
// import AWS from "aws-sdk";
import { useDispatch, useSelector } from "react-redux";
import Card from '@mui/material/Card';
import CardActions from '@mui/material/CardActions';
import CardContent from '@mui/material/CardContent';
import Button from '@mui/material/Button';
import Typography from '@mui/material/Typography';
import CardMedia from "@mui/material/CardMedia";
import { ServiceApi } from "../../services/index.service";
import { updateAddToCart } from '../../redux/purchaseRequest/purchaseRequestSlice';
import { Backdrop, Chip, CircularProgress, Grid, Stack } from "@mui/material";
import "./cards.css";
import { ImagePopup } from './ImagePopup';
import { updateProductCategories } from '../../redux/purchaseRequest/purchaseRequestSlice';
import { useNavigate } from "react-router-dom";
import { GetLocalStore } from '../../utils/storage';

export default function PurchaseCard(props) {

const dispatch                                        = useDispatch();
const navigate                                        = useNavigate();
const data                                            = useSelector((state) => state);
const { addedItems: existingAddedProducts }           = data?.purchaseRequest;
const isNotAdmin                                      = data?.profile?.Group !== "Administrators";

const [loading, setLoading]                           = React.useState(false);
const [products, setProducts]                         = React.useState([])
const [purchaseCategoryList, setPurchaseCategoryList] = React.useState([])
const [openDialog, setOpenDialog]                     = React.useState(false);
const [imageData, setImageData]                       = React.useState({})
const [selectedCategory, setSelectedCategory]         = React.useState(0);
const serviceapi                                      = new ServiceApi();


const addtocart = (product) => {
  const isProductAdded = checkIfProductIsAlreadyAddedTOCart(product);
  if (isProductAdded) {
    console.log('product is already added to the cart');
  } else 
  {
    product.quantity = 1;
    product.subtotal = product.price;
    // dispatch an action to store
    dispatch(updateAddToCart(product));
  }
};

const checkIfProductIsAlreadyAddedTOCart = (productItem) => {
  const filteredProducts = existingAddedProducts.filter((item) => item.id === productItem.id)
  return filteredProducts?.length > 0;
}

const getPurchaseMerchendise = async () => {
  setLoading(true);
  const response = await serviceapi?.fetchPurchaseMerchendise();
  setLoading(false);
  const productList = response?.Products?.filter(i=>i?.status);
  setProducts(productList);
  setPurchaseCategoryList(response?.Categories)
  dispatch(updateProductCategories(response?.Categories))
};

React.useEffect(() => {
  if(GetLocalStore('token')){
    getPurchaseMerchendise();
  }
}, [])

let filtered = products
if (selectedCategory !== 0) 
{
  filtered = products?.filter(
    (i) => i?.category_id === selectedCategory
  )
}

const handleConfirmDialog = () => {
  setOpenDialog(!openDialog);
}

const openImagePopup = (product) => {
  let image = {
    'name'       : product?.name,
    'img_thumbs' : JSON.parse(product?.images)[0].url,
    'data':product
  }
  setImageData(image)
  setOpenDialog(!openDialog);
}

const handleManageProducts=()=>{
  if(props.directUrl){
    navigate('/manage-merchandise-products')
  }else{
    navigate('/manage-merchandise')
  }
}

const renderProducts = () => (
  <div className="py-6 mt-16">
    {/* HEADER */}
    <header>
      <div className="flex justify-between items-center mx-auto max-w-7xl px-4 sm:px-6 lg:px-8">
        {props.directUrl? null:  <h1 className="text-2xl font-display font-medium leading-tight text-secondary">
          Purchase Merchandise
        </h1>}
        <div className="flex justify-end gap-2 items-baseline">
          <div className=" pl-2">
            <Stack spacing={1} alignItems="center">
              <Stack direction="row" spacing={2}>
                <Chip
                  label="All"
                  color={ selectedCategory === 0 ? "primary" : "default" }
                  onClick={ () => setSelectedCategory(0) }
                />
                {
                  purchaseCategoryList?.map((i) => (
                    <>
                      <Chip
                        label={i?.name}
                        key={i?.id}
                        color={ selectedCategory === i?.id ? "primary" : "default" }
                        onClick={ () => setSelectedCategory(i?.id) }
                      />
                    </>
                  ))
                }
              </Stack>
            </Stack>
          </div>
        </div>

        <Button hidden={isNotAdmin} variant="outlined" color='error'
          onClick={() => handleManageProducts()}
          className=""
        >
          Manage Products
        </Button>
      </div>
    </header>

    {/* BODY */}
    <main>
      <div className="mx-auto max-w-7xl sm:px-6 lg:px-8">
        <div className="px-4 py-8 sm:px-0">
          <div className="w-full grid xs:grid-cols-2 sm:grid-cols-3 md:grid-cols-4 lg:grid-cols-4 xl:grid-cols-5 gap-6">
            {filtered?.length > 0 && filtered.map((product) => {
              const { images } = product;
              let productImage = images;
              if (images && images !== 'NA') {
                productImage = JSON.parse(images);
              }
              return (
                <Card key={product?.id} className="purchase_merchendise_cards">
                  <div className="purchase_card_dev">
                    <div className="flex img_container">
                      <CardMedia
                        component="img"
                        alt="drive board image" className="purchase_merchendise_cards_img"
                        image={productImage[0]?.url}
                        onClick={() => openImagePopup(product)}
                      >
                      </CardMedia>
                    </div>
                  </div>
                  <CardContent style={{ padding: '5px 15px' }}>
                    <Typography variant="body2" color="text.secondary" className="Purchase_merchendise_name" title={product?.name}>
                      {product?.name.substring(0, 55)}...
                    </Typography>
                  </CardContent>
                  <div className="purchase_card_price"> ${product.price}</div>
                  <CardActions className="cards_actions">
                    <Button
                      onClick={() => addtocart(product)}
                      className="Purchase_card_aad_to_cart_btn"
                      sx={{ textTransform: 'capitalize !important' }}
                      disabled={checkIfProductIsAlreadyAddedTOCart(product)}
                    >
                      Add To Cart
                    </Button>
                  </CardActions>
                </Card>
              )
            })
            }
          </div>
        </div>
      </div>
    </main>
  </div>
);

return (
  <div>
    <Backdrop
      sx={{ color: "#fff", zIndex: (theme) => theme.zIndex.drawer + 1 }}
      open={loading}
    >
      <CircularProgress color="inherit" />
    </Backdrop>
    {openDialog && <ImagePopup openDialog={openDialog} handleConfirmDialog={handleConfirmDialog} imageData={imageData} Categories={purchaseCategoryList} />}
    {renderProducts()}
  </div>
);
}
